import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import styled from "@emotion/styled";

import { SubHeaderStyle } from '../../styles/styles';
import { COLORS_BASE } from '../../utils/consts';

type SubHeaderProps = { 
  text: string,
  icon: IconDefinition,
};

function SubHeader({text, icon}: SubHeaderProps) {
  return (
    <SubHeaderContainerStyle>
      <FontAwesomeIcon icon={icon} color={COLORS_BASE.BRAND.DARKER}/>
      <SubHeaderStyle>{text}</SubHeaderStyle>
    </SubHeaderContainerStyle>
  )
}

export default SubHeader;

const SubHeaderContainerStyle = styled.div<{}>(
  () => `
    height: inherit;
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
`
);